import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";

import HeadingBanner from "../components/HeadingBanner";

import LeftPanel from "../components/LeftPanel";
import OrientationPrompt from "../components/OrientationPrompt";
import FreeTrialBanner from "../components/FreeTrialBanner";

import {
  whoami,
  getClasses,
  getTeachers,
  getSchools,
  getTrialistsBySchool,
  getScreeningWindowStatuses,
  getPilotBySchoolId,
  getCountryId,
  hasEntityAccess,
  getMessageByMessageId,
} from "../services/APIClient";

import { Container, Row, Col } from "react-bootstrap";

import "../components/ClassCard.css";
import "../components/AdminDashCards.css";
const AlpacaInfoGesture = React.lazy(() =>
  import("../components/AlpacaInfoGesture")
);

const VideoModal = React.lazy(() =>
  import("../components/VideoModal")
);


const buttonStyle = {
  // width: '80%',
  padding: '16px 24px',
  fontSize: '2.5vh',
  fontWeight: '600',
  backgroundColor: '#FF6B35',
  color: '#FFFFFF',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
  transition: 'none',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  outline: 'none',
  marginBottom: '1%',
  width: '100%'
};


function AdminDashboard() {
  const [schoolid, setSchoolid] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [teachers, setTeachers] = useState(null);
  const [rollNumber, setRollNumber] = useState(null);
  const [teacherEmail, setTeacherEmail] = useState(null);
  const [speechText, setSpeechText] = useState(null);
  const [classes, setClasses] = useState([]);
  const [classid, setClassid] = useState([]);
  const [loading, setLoading] = useState(true);
  const [trialistDetails, setTrialistDetails] = useState(null);
  const [freeDaysLeft, setFreeDaysLeft] = useState(null);
  const [hasSchoolAdminAccess, setHasSchoolAdminAccess] = useState(false);
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  const [countryid, setCountryid] = useState(null);
  const [existingConversionMethods, setExistingConversionMethods] = useState([]);
  const [pilotData, setPilotData] = useState(null);
  const [screeningWindowData, setScreeningWindowData] = useState(null);
  const [adminMessage, setAdminMessage] = useState(null);
  const DEFAULT_COUNTRY_ID = '07d45b79-24b1-435f-b82a-93861b23a86e';
  const isPilot = pilotData && pilotData.length > 0 && pilotData[0].active;

  const now = new Date();

  // ✅ Add staging check
  const isStaging =
    window.location.href.includes("staging") ||
    window.location.href.includes("localhost") ||
    window.location.href.includes("alpaca-assessment-test");

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
      setTeacherid(response.data.stakeholder.id);
      setName(response.data.stakeholder.name);
      setTeacherEmail(response.data.email);
    });
  }, []);

  useEffect(() => {
    if (schoolid) {
      Promise.all([getTeachers(schoolid), getClasses(), getSchools()])
        .then(([teachersResponse, classesResponse, schoolsResponse]) => {
          setTeachers(teachersResponse);
          setClasses(classesResponse);
          setClassid(classesResponse.id);

          const matchingSchool = schoolsResponse.data.find(
            (school) => school.id === schoolid
          );

          if (matchingSchool) {
            const rollNumber = matchingSchool.rollnumber;
            setRollNumber(rollNumber);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false after data is fetched
        });
    }
  }, [schoolid]);

  useEffect(() => {
    setSpeechText(
      `Now lets click into "My Classes" and "Create a New Class" and add students to it.`
    );
  }, [name, schoolid]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    const fetchTrialistDetails = async () => {
      try {
        const response = await getTrialistsBySchool(schoolid); // Fetch data
        if (response.length > 0) {
          const details = response[0]; // Assuming we use the first trial entry
          setTrialistDetails(details);

          // Calculate freeDaysLeft
          const currentDate = new Date();
          const endDate = new Date(details.end_date);
          const timeDiff = endDate - currentDate; // Difference in milliseconds
          const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert to days
          setFreeDaysLeft(daysLeft > 0 ? daysLeft : 0); // Ensure non-negative value
        }
      } catch (error) {
        console.error("Failed to fetch trialist details:", error);
      }
    };
    fetchTrialistDetails();
  }, [schoolid]);

  useEffect(() => {
    if (schoolid) {
      hasEntityAccess('school', schoolid, 'school_admin_access')
        .then((hasAccess) => {
          setHasSchoolAdminAccess(hasAccess);
        })
        .catch((error) => {
          console.error("Failed to check school admin access:", error);
          setHasSchoolAdminAccess(false);
        });
    }
  }, [schoolid]);

  useEffect(() => {
    if (schoolid) {
      console.log('🔍 Fetching countryid for schoolid:', schoolid);
      getCountryId(schoolid)
        .then((response) => {
          if (response.countryId) {
            console.log('✅ Country ID response:', response);
            setCountryid(response.countryId);
          } else {
            console.warn("⚠️ No country ID found for school:", response.message);
            setCountryid(null);
          }
        })
        .catch((error) => {
          console.error("❌ Failed to fetch country ID:", error);
          setCountryid(null);
        });
    }
  }, [schoolid]);

  // Fetch the admin message from the database
  useEffect(() => {
    if (countryid) {
      getMessageByMessageId(countryid, 'admin_message')
        .then((msg) => {
          if (msg) {
            setAdminMessage(msg);
          }
        })
        .catch((error) => {
          console.error('Failed to fetch admin message:', error);
        });
    }
  }, [countryid]);

  useEffect(() => {
    if (!schoolid) return;

    const fetchPilotData = async () => {
      try {
        const pilotResponse = await getPilotBySchoolId(schoolid);
        setPilotData(pilotResponse);
      } catch (error) {
        console.error('Error fetching pilot data:', error);
      }
    };

    fetchPilotData();
  }, [schoolid]);
  
  useEffect(() => {
    console.log('🚀 fetchPilotAndScreeningData useEffect triggered');
    console.log('📍 Current values:', { schoolid, countryid });

    const fetchScreeningWindowData = async () => {
      if (!schoolid || !countryid) {
        console.log('❌ Missing required values, returning early:', { schoolid, countryid });
        return;
      }

      try {
        // Fetch screening window status
        console.log('🔍 Fetching screening window for countryid:', countryid);

        let screeningResponse = await getScreeningWindowStatuses({
          countryid: countryid,
          active: true
        });

        console.log('📊 Screening window data (original):', screeningResponse);

        // If no results, fallback to default
        if (!screeningResponse || screeningResponse.length === 0) {
          console.log('⚠️ Using default countryid:', DEFAULT_COUNTRY_ID);
          screeningResponse = await getScreeningWindowStatuses({
            countryid: DEFAULT_COUNTRY_ID,
            active: true
          });
          console.log('📊 Screening window data (default):', screeningResponse);
        }

        setScreeningWindowData(screeningResponse);

      } catch (error) {
        console.error('❌ Error fetching pilot/screening data:', error);
      }
    };

    fetchScreeningWindowData();
  }, [schoolid, countryid]);

  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={name + "'s" + " " + "Admin"}
          isLoggedIn={true}
          cloud={true}
          schoolid={schoolid}
          teacherid={teacherid}
          pilotData={pilotData}
          screeningWindowData={screeningWindowData}
        />

        <Row className="h-100">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            {loading ? (
              <div className="spinner-container">
                <div className="big-ball-spinner"></div>
              </div>
            ) : (
              <Row className="admindash-row-position">
                <Row>
                  <FreeTrialBanner
                    schoolid={schoolid}
                    teacherName={name}
                    freeDaysLeft={freeDaysLeft}
                    trialistDetails={trialistDetails}
                    pilotData={pilotData}
                  />
                </Row>
                {/* <VideoModal
                      buttonText="📺 Click here to see useful video guides on how to use the Teacher Dashboard"
                      modalTitle="How to use the Teacher Dashboard"
                      videos={[
                        {
                          title: "Navigating the Teacher Dashboard",
                          iframe: "https://www.youtube.com/embed/Gd9uNam1YqA?si=rg7kojO760MBHWvk"
                        },
                        {
                          title: "How to Share a Class with a Colleague",
                          iframe: "https://www.youtube.com/embed/WI2EiLKhxo0?si=n4pEHXQzG4ZZU7Ne"
                        }
                        ,
                        {
                          title: "How to Invite Colleagues",
                          iframe: "https://www.youtube.com/embed/ZzcP4ZAVOBg?si=4PR8xUsxIDPZBkpA"
                        }
                        ,
                        {
                          title: "20 minute video",
                          iframe: "https://www.youtube.com/embed/1cYyO_Yv7YE?si=AqQIvZ-tZd-ANLS1"
                        }
                      ]}
                    /> */}

                {adminMessage && (
                  adminMessage.hyperlink ? (
                    <a href={adminMessage.hyperlink} target="_blank" rel="noopener noreferrer">
                      <button
                        style={buttonStyle}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#FF6B35';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#FF6B35';
                        }}
                        onFocus={(e) => {
                          e.target.style.outline = 'none';
                        }}
                      >
                        {adminMessage.text}
                      </button>
                    </a>
                  ) : adminMessage.route ? (
                    <Link to={adminMessage.route}>
                      <button
                        style={buttonStyle}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#FF6B35';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = '#FF6B35';
                        }}
                        onFocus={(e) => {
                          e.target.style.outline = 'none';
                        }}
                      >
                        {adminMessage.text}
                      </button>
                    </Link>
                  ) : null
                )}
                <Col className="col-4">
                  <Card className="admindash-card-detail">
                    <Link
                      className="link"
                      to={`/classadmindashboard`}
                      state={{
                        classDetails: { classes },
                        teachers: { teachers },
                        name: { name },
                        rollNumber: { rollNumber },
                        teacherEmail: { teacherEmail },
                      }}
                    >
                      <img
                        src="./assets/imgs/Asset-class.webp"
                        className="admin-class-card-img"
                      ></img>
                      <p className="class-card-text">My Classes</p>
                    </Link>
                  </Card>
                </Col>
                {classes.length !== 0 ? (
                  <>
                    <Col className="col-4">
                      <Card className="admindash-card-detail">
                        {/* 
                          className="link"
                          href={`https://26983596.hs-sites-eu1.com/other-colleagues/?roll_number_contact=${rollNumber}&email=${teacherEmail}`}
                          target="_blank"
                        >
                        
                          <p className="class-card-text">My Colleagues</p>
                        </a> */}
                        {/* 
                          className="link"
                          href={`https://26983596.hs-sites-eu1.com/other-colleagues/?roll_number_contact=${rollNumber}&email=${teacherEmail}`}
                          target="_blank"
                        >
                        
                          <p className="class-card-text">My Colleagues</p>
                        </a> */}
                        <Link
                          className="link"
                          to={`/mycolleagues`}
                          state={{
                            classDetails: { classes },
                            teachers: { teachers },
                            name: { name },
                            rollNumber: { rollNumber },
                            teacherEmail: { teacherEmail },
                          }}
                        >
                          <img
                            src="./assets/imgs/mycolleagues-icon.png"
                            className="admin-class-card-img "
                          ></img>
                          <p className="class-card-text">My Colleagues</p>
                        </Link>
                      </Card>
                    </Col>
                    <Col className="col-4">
                      <Card className="admindash-card-detail">
                        <Link
                          className="link"
                          to={`/profile`}
                          state={{
                            classDetails: { classes },
                            teachers: { teachers },
                            name: { name },
                          }}
                        >
                          <img
                            src="./assets/imgs/myinfo-icon.png"
                            className="admin-class-card-img"
                          ></img>
                          <p className="class-card-text">My Info</p>
                        </Link>
                      </Card>
                    </Col>

                    {/* School Admin Card (Tag-Based Access Control) */}
                    {hasSchoolAdminAccess && (
                      <Col className="col-4">
                        <Card className="admindash-card-detail" style={{
                          background: '#00A87E',
                          border: 'none'
                        }}>
                          <button
                            type="button"
                            className="link"
                            disabled
                            aria-describedby="school-admin-unavailable"
                            style={{
                              cursor: 'not-allowed',
                              position: 'relative',
                              width: '100%',
                              border: 0,
                              background: 'transparent'
                            }}
                          >
                            <div style={{
                              position: 'absolute',
                              top: '10px',
                              right: '10px',
                              background: '#f39c12',
                              color: '#fff',
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '0.7rem',
                              fontWeight: 'bold'
                            }}>
                              EARLY ACCESS
                            </div>
                            <div className="admin-class-card-img" style={{
                              fontSize: '120px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '200px'
                            }}>
                              🏫
                            </div>
                            <p className="class-card-text" style={{ color: '#fff' }}>School Admin</p>
                          </button>
                          <p id="school-admin-unavailable" style={{ color: '#fff' }}>
                            Secure School Admin access is temporarily unavailable.
                          </p>
                        </Card>
                      </Col>
                    )}
                  </>
                ) : (
                  <AlpacaInfoGesture speechText={speechText} />
                )}
              </Row>
            )}
          </Col>
        </Row>
      </Container>
      {isPortrait && <OrientationPrompt />}
    </div>
  );
}

export default AdminDashboard;
